/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type appCalendar_viewer$ref: FragmentReference;
declare export opaque type appCalendar_viewer$fragmentType: appCalendar_viewer$ref;
export type appCalendar_viewer = {|
  +id: string,
  +company: ?{|
    +id: string,
    +calendarEnabled: ?boolean,
    +calendarApiEnabled: ?boolean,
    +outlookCalendarApiEnabled: ?boolean,
  |},
  +$refType: appCalendar_viewer$ref,
|};
export type appCalendar_viewer$data = appCalendar_viewer;
export type appCalendar_viewer$key = {
  +$data?: appCalendar_viewer$data,
  +$fragmentRefs: appCalendar_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appCalendar_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "calendarEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "calendarApiEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "outlookCalendarApiEnabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
// prettier-ignore
(node/*: any*/).hash = '378aedbf59dd58107b3c4a9fcd026c48';

module.exports = node;
